import React, {Fragment} from 'react'
import DatePicker from "../../Components/DatePicker"
import {Input, Label} from "reactstrap"
import _padStart from "lodash/padStart"

export default class MoreOptions extends React.Component {
    constructor(props) {
        super(props)
    }

    renderHours = () => {
        let result = []
        let minutes = ['00', '15', '30', '45']
        for (let i = 0; i <= 23; i++) {
            result = result.concat(minutes.map((m) => {
                let h = _padStart((i.toString() + ':' + m), 5, '0')
                return (
                    <option key={h} value={h}>{h}</option>
                )
            }))
        }
        return result
    }


    render() {
        const {model, id, params} = this.props
        return (
            <div className={'row ml-sm-2'}>
                <div className={'col-12 col-sm-6 mb-2'}>
                    Preluare:{' '}
                    <DatePicker
                        date={new Date(params.start_date)}
                        onChangeDate={date => this.props.handleDateChange('start_date', id, date)}
                        noDisabledDays
                        className={'d-inline-block mr-2 mb-2'}/>
                    <div className={'d-inline-block mr-3'}>
                        <Input
                            type={'select'}
                            name={`start_hour-${id}`}
                            value={model.start_hour}
                            onChange={this.props.handleChange}>
                            {this.renderHours()}
                        </Input>
                    </div>
                </div>
                <div className={'col-12 col-sm-6 mb-2'}>
                    Returnare:{' '}
                    <DatePicker
                        date={new Date(params.end_date)}
                        onChangeDate={date => this.props.handleDateChange('end_date', id, date)}
                        noDisabledDays
                        className={'d-inline-block mr-2 mb-2'}/>
                    <div className={'d-inline-block'}>
                        <Input
                            type={'select'}
                            name={`end_hour-${id}`}
                            value={model.end_hour}
                            onChange={this.props.handleChange}>
                            {this.renderHours()}
                        </Input>
                    </div>
                </div>
                <div className={'col-12 col-sm-4 mb-2'}>
                    Tip asigurare:{' '}
                    <div className={'d-inline-block mr-2'}>
                        <Input
                            type={'select'}
                            name={`insurance_type-${id}`}
                            value={model.insurance_type}
                            onChange={this.props.handleChange}
                            style={{maxWidth: 200}}>
                            {params.insurances.map(i =>
                                <option key={i[0]} value={i[0]}>{i[1]}</option>)}
                        </Input>
                    </div>
                </div>
                <div className={'col-12 col-sm-4 mb-2'}>
                    Asigurare:{' '}
                    <div className={'d-inline-block'}>
                        <Input
                            type={'number'} step={'any'}
                            name={`insurance-${id}`}
                            value={model.insurance}
                            onChange={this.props.handleChange}
                            className={'d-inline'}
                            style={{width: 100}}/>
                    </div>
                    {' '}EUR/zi{' '}
                </div>
                <div className={'col-12 col-sm-4 mb-2'}>
                    Depozit:{' '}
                    <div className={'d-inline-block'}>
                        <Input
                            type={'number'} step={'any'}
                            name={`deposit-${id}`}
                            value={model.deposit}
                            onChange={this.props.handleChange}
                            className={'d-inline'}
                            style={{width: 100}}/>
                    </div>
                    {' '}EUR
                </div>
                <div className={'col-12 mb-2'}>
                    <Label htmlFor={`message-${id}`}>Mesaj:</Label>
                    <Input type={'textarea'} name={`message-${id}`} id={`message-${id}`} onChange={this.props.handleChange}/>
                </div>
            </div>
        )
    }
}